var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Header/Logo.js",
  _this = this;
import React from 'react';
import Text from '../Text';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
var StyledLogoAnchor = withTheme(styled(Text).withConfig({
  displayName: "Logo__StyledLogoAnchor",
  componentId: "sc-1svcjz0-0"
})(function (props) {
  return css(["display:block;height:", ";align-self:", ";"], props.coreTheme.header.deskTopLogoHeight, props.mode === 'deskTop' && props.coreTheme.header.logoAlignment);
}));
var StyledLogoImg = styled.img.withConfig({
  displayName: "Logo__StyledLogoImg",
  componentId: "sc-1svcjz0-1"
})(["height:100%;"]);
var Logo = function Logo(_ref) {
  var baseUrl = _ref.baseUrl,
    href = _ref.href,
    alt = _ref.alt,
    src = _ref.src,
    mode = _ref.mode;
  return /*#__PURE__*/React.createElement(StyledLogoAnchor, {
    type: "link",
    href: "".concat(baseUrl).concat(href),
    mode: mode,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(StyledLogoImg, {
    src: src,
    alt: alt,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 5
    }
  }));
};
export default Logo;